import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage } from '@fortawesome/free-solid-svg-icons';

// Soft, on-brand placeholder shown when media is missing or fails to load.
// Fills its nearest `relative` parent, so keep the media container positioned.
export const MediaFallback = ({ icon = faImage, label }) => (
    <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 select-none
                    bg-gradient-to-br from-brand-50 via-brand-100 to-brand-100
                    dark:from-gray-700 dark:via-gray-800 dark:to-gray-800
                    text-brand-400 dark:text-gray-500">
        <FontAwesomeIcon icon={icon} className="text-4xl opacity-70" />
        {label && (
            <span className="text-xs font-medium px-3 text-center truncate max-w-[90%]
                             text-brand-600/70 dark:text-gray-400">
                {label}
            </span>
        )}
    </div>
);

// Drop-in <img> replacement that swaps to <MediaFallback> on load error or empty src.
export const ImageWithFallback = ({ src, alt, label, icon, className, ...rest }) => {
    const [failed, setFailed] = useState(!src);

    if (failed) return <MediaFallback icon={icon} label={label ?? alt} />;

    return (
        <img
            src={src}
            alt={alt}
            loading="lazy"
            onError={() => setFailed(true)}
            className={className}
            {...rest}
        />
    );
};

export default ImageWithFallback;
